module.exports = __webpack_public_path__ + "b41eee4f7db90d121bcaffe3efdb8b1e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/court.jpeg
// module id = 637
// module chunks = 0